import { IBondGrossReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_DELTA_LINKED';

export type IReportGrossDeltaLinkedItem = IBondGrossReport & { __isSelected: boolean };
